module.exports = __webpack_public_path__ + "static/img/shop_cart.b736ff1.1780911843607.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cartimg/shop_cart.png
// module id = BKp6
// module chunks = 75